<template>
  <div>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 box mt-5">
        <div
          class="flex flex-col sm:flex-row items-center p-5 border-b dark:border-dark-5 border-gray-200"
        >
          <h2
            v-if="
              $store.state.auth.isLogined &&
                $store.state.auth.user?.isAdmin == 1
            "
            class="font-medium text-base mr-auto"
          >
            지점목록
          </h2>
          <h2 v-else class="font-medium text-base mr-auto">
            지점
          </h2>
          <div
            v-if="
              $store.state.auth.isLogined &&
                $store.state.auth.user?.isAdmin == 1
            "
            class="w-full sm:w-auto flex items-center sm:ml-auto mt-3 sm:mt-0"
          >
            <button
              class="button text-white bg-theme-1 shadow-md mr-2"
              @click="clickAddBtn"
            >
              지점등록
            </button>
          </div>
        </div>
        <!-- BEGIN: Data List -->
        <div
          class="intro-y col-span-12 overflow-auto lg:overflow-visible py-5 px-10"
        >
          <table class="table -mt-2 col-span-12">
            <thead>
              <tr class="text-gray-700 col-span-2">
                <th class="border-b-2 dark:border-dark-5 whitespace-no-wrap">
                  <div class="font-medium whitespace-no-wrap">
                    번호
                  </div>
                </th>
                <th
                  class="border-b-2 dark:border-dark-5 whitespace-no-wrap col-span-2"
                >
                  <div class="font-medium whitespace-no-wrap">
                    이름
                  </div>
                </th>
                <th
                  class="border-b-2 dark:border-dark-5 whitespace-no-wrap col-span-3"
                >
                  <div class="font-medium whitespace-no-wrap">
                    원화
                  </div>
                </th>
                <th
                  class="border-b-2 dark:border-dark-5 whitespace-no-wrap col-span-3"
                >
                  <div class="font-medium whitespace-no-wrap">
                    통장잔고
                  </div>
                </th>
                <th
                  class="border-b-2 dark:border-dark-5 text-center whitespace-no-wrap col-span-3"
                >
                  <div class="font-medium whitespace-no-wrap">
                    편집
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(agency, index) in categories"
                :key="index"
                class="intro-x border-b-2 dark:border-dark-5"
              >
                <td>
                  <div class="font-medium whitespace-no-wrap py-1">
                    {{ index + 1 }}
                  </div>
                </td>
                <td>
                  <div class="font-medium whitespace-no-wrap">
                    {{ agency.name }}
                  </div>
                </td>
                <td>
                  <div class="font-medium whitespace-no-wrap">
                    {{ $h.filterCurrency(agency.localAmount) }}
                  </div>
                </td>
                <td>
                  <div class="font-medium whitespace-no-wrap">
                    {{ $h.filterCurrency(agency.bankAmount) }}
                  </div>
                </td>
                <td class="table-report__action w-56">
                  <div class="flex justify-center items-center">
                    <a
                      class="flex items-center mr-3"
                      href="javascript:;"
                      @click="clickHistoryBtn(agency)"
                    >
                      <feather-icon
                        type="history"
                        size="16"
                        class="w-4 h-4 mr-1"
                      />
                      이력
                    </a>
                    <a
                      class="flex items-center mr-3"
                      href="javascript:;"
                      @click="clickEditBtn(agency)"
                    >
                      <CheckSquareIcon class="w-4 h-4 mr-1" />
                      수정
                    </a>
                    <a
                      class="flex items-center text-theme-6"
                      href="javascript:;"
                      @click="clickDeleteBtn(agency)"
                    >
                      <Trash2Icon class="w-4 h-4 mr-1" /> 삭제
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- END: Data List -->
      </div>
      <!-- BEGIN: Delete Confirmation Modal -->
      <div id="delete-confirmation-modal" class="modal">
        <div class="modal__content">
          <div class="p-5 text-center">
            <xCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
            <div class="text-3xl mt-5 mb-5">삭제 하시겠습니까?</div>
          </div>
          <div class="px-5 pb-8 text-center">
            <button
              type="button"
              data-dismiss="modal"
              class="button w-24 border text-gray-700 mr-1"
            >
              취소
            </button>
            <button
              type="button"
              data-dismiss="modal"
              class="button w-24 bg-theme-6 text-white"
              @click="handleDelete"
            >
              삭제
            </button>
          </div>
        </div>
      </div>
      <!-- END: Delete Confirmation Modal -->
      <!-- BEGIN: Delete Confirmation Modal -->
      <div id="format-confirmation-modal" class="modal">
        <div class="modal__content">
          <div class="p-5 text-center">
            <xCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
            <div class="text-3xl mt-5 mb-5">초기화 하시겠습니까?</div>
          </div>
          <div class="px-5 pb-8 text-center">
            <button
              type="button"
              data-dismiss="modal"
              class="button w-24 border text-gray-700 mr-1"
            >
              취소
            </button>
            <button
              type="button"
              data-dismiss="modal"
              class="button w-24 bg-theme-6 text-white"
              @click="handleFormat"
            >
              초기화
            </button>
          </div>
        </div>
      </div>
      <!-- END: Delete Confirmation Modal -->
      <!-- BEGIN: Update Confirmation Modal -->
      <div id="update-confirmation-modal" class="modal">
        <div class="modal__content" style="width: 40vw;">
          <div class="p-5 text-center">
            <feather-icon
              type="alert-triangle"
              class="w-16 h-16 text-blue-500 mx-auto mt-3"
            />
            <div class="text-2xl mt-5 mb-5">
              원화를
              {{ formatIntIfString(String(originalRegister.localAmount)) }} ->
              {{ formatIntIfString(String(register.localAmount)) }}
              원으로,<br />
              통장잔고를
              {{ formatIntIfString(String(originalRegister.bankAmount)) }} ->
              {{ formatIntIfString(String(register.bankAmount)) }}
              원으로<br />수정 하시겠습니까?
            </div>
          </div>
          <div class="px-5 pb-8 text-center">
            <button
              type="button"
              data-dismiss="modal"
              class="button w-24 border text-gray-700 mr-1"
            >
              취소
            </button>
            <button
              type="button"
              :disabled="isSubmitting"
              data-dismiss="modal"
              class="button w-24 bg-theme-6 text-white"
              @click="handleConfirmUpdate"
            >
              <span v-if="isSubmitting">처리중</span>
              <span v-else>수정</span>
            </button>
          </div>
        </div>
      </div>
      <!-- END: Update Confirmation Modal -->
      <div id="header-footer-modal-preview" class="modal">
        <div class="modal__content">
          <div
            class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5 relative"
          >
            <h2 class="font-medium text-base mr-auto">지점등록</h2>
            <a
              data-dismiss="modal"
              href="javascript:;"
              class="absolute right-0 top-0 mt-3 mr-3"
            >
              <xIcon class="w-8 h-8 text-gray-500" />
            </a>
          </div>
          <div class="px-10 py-5 grid grid-cols-12 row-gap-2">
            <div class="col-span-12">
              <div class="flex flex-col sm:flex-row items-center">
                <label class="w-full sm:w-20 sm:text-left sm:mr-5">
                  이름
                </label>
                <input
                  id="inputEmail"
                  v-model="register.name"
                  type="email"
                  placeholder="이름을 입력하세요"
                  autocomplete="off"
                  class="input w-full border mt-2 flex-1"
                  @keyup.enter="inputEmailEnter"
                />
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col sm:flex-row items-center">
                <label class="w-full sm:w-20 sm:text-left sm:mr-5">
                  원화
                </label>
                <currency-input
                  id="inputLocalAmount"
                  v-model="register.localAmount"
                  currency="KRW"
                  autocomplete="off"
                  class="input w-full border mt-2 flex-1"
                  @keyup.enter="inputLocalAmountEnter"
                />
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col sm:flex-row items-center">
                <label class="w-full sm:w-20 sm:text-left sm:mr-5">
                  통장잔고
                </label>
                <currency-input
                  id="inputBankAmount"
                  v-model="register.bankAmount"
                  currency="KRW"
                  autocomplete="off"
                  class="input w-full border mt-2 flex-1"
                  @keyup.enter="inputBankAmountEnter"
                />
              </div>
            </div>
          </div>
          <div
            class="px-5 py-3 text-right border-t border-gray-200 dark:border-dark-5"
          >
            <button
              type="button"
              data-dismiss="modal"
              class="button w-20 border text-gray-700 dark:border-dark-5 dark:text-gray-300 mr-1"
            >
              취소
            </button>
            <button
              type="button"
              data-dismiss="modal"
              class="button w-20 bg-theme-1 text-white"
              @click="handleRegister"
            >
              등록
            </button>
          </div>
        </div>
      </div>
      <div id="edit-modal-preview" class="modal">
        <div class="modal__content">
          <div
            class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5 relative"
          >
            <h2 class="font-medium text-base mr-auto">지점수정</h2>
            <a
              data-dismiss="modal"
              href="javascript:;"
              class="absolute right-0 top-0 mt-3 mr-3"
            >
              <xIcon class="w-8 h-8 text-gray-500" />
            </a>
          </div>
          <div class="px-10 py-5 grid grid-cols-12 row-gap-2">
            <div class="col-span-12">
              <div class="flex flex-col sm:flex-row items-center">
                <label class="w-full sm:w-20 sm:text-left sm:mr-5">
                  이름
                </label>
                <input
                  v-model="register.name"
                  type="email"
                  placeholder="이름을 입력하세요"
                  autocomplete="off"
                  class="input w-full border mt-2 flex-1"
                />
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col sm:flex-row items-center">
                <label class="w-full sm:w-20 sm:text-left sm:mr-5">
                  원화
                </label>
                <input
                  v-model="formatRegister.tempLocalAmount"
                  autocomplete="off"
                  class="input w-full border mt-2 flex-1"
                  @input="handleFormatAmount($event, 1)"
                  @keyup.enter="onClickUpdate($event)"
                />
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col sm:flex-row items-center">
                <label class="w-full sm:w-20 sm:text-left sm:mr-5">
                  통장잔고
                </label>
                <input
                  v-model="formatRegister.tempBankAmount"
                  autocomplete="off"
                  class="input w-full border mt-2 flex-1"
                  @input="handleFormatAmount($event, 2)"
                  @keyup.enter="onClickUpdate($event)"
                />
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col sm:flex-row items-center">
                <label class="w-full sm:w-20 sm:text-left sm:mr-5">
                  비고
                </label>
                <input
                  v-model="register.notes"
                  type="text"
                  placeholder="수정 사유를 입력하세요"
                  autocomplete="off"
                  class="input w-full border mt-2 flex-1"
                  @keyup.enter="onClickUpdate($event)"
                />
              </div>
            </div>
          </div>
          <div
            class="w-full flex px-5 py-3 border-t border-gray-200 dark:border-dark-5"
          >
            <button
              type="button"
              data-dismiss="modal"
              class="button w-20 border text-white dark:border-dark-5 dark:text-gray-300 mr-1 bg-theme-6 mr-auto ml-5"
              @click="onClickFormat"
            >
              초기화
            </button>
            <button
              type="button"
              data-dismiss="modal"
              class="button w-20 border text-gray-700 dark:border-dark-5 dark:text-gray-300 mr-1"
            >
              취소
            </button>
            <button
              type="button"
              :disabled="isSubmitting"
              class="button w-20 bg-theme-1 text-white mr-5"
              @click="onClickUpdate($event)"
            >
              <span v-if="isSubmitting">처리중...</span>
              <span v-else>수정</span>
            </button>
          </div>
        </div>
      </div>
      <!-- BEGIN: Update History Confirmation Modal -->
      <div id="update-history-modal" class="modal">
        <div class="modal__content" style="width: 60vw;">
          <div class="p-5 text-center">
            <div class="text-3xl mt-5 mb-5 p-2">
              지점수정내역
            </div>
            <el-date-picker
              v-if="$store.state.auth.user?.isAdmin == 1"
              v-model="update_agency_pages_days"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="~"
              start-placeholder="시작날짜"
              end-placeholder="마지막날짜"
              value-format="yyyy-MM-dd"
              class="flex inline-block mt-3 lg:mt-0 p-2"
              @change="onChangeAgencyHistoryLogDay"
            >
            </el-date-picker>
          </div>
          <div id="bordered-table" class="p-5">
            <div class="preview">
              <div class="overflow-x-auto">
                <table class="table">
                  <thead>
                    <th
                      class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                    >
                      업데이트 일시
                    </th>
                    <th
                      class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                    >
                      수정 항목
                    </th>
                    <th
                      class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                    >
                      기존 값
                    </th>
                    <th
                      class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                    >
                      변경 후 값
                    </th>
                    <th
                      class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                    >
                      차액금
                    </th>
                    <th class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center">
                      비고
                    </th>
                  </thead>
                  <tbody>
                    <template v-for="groupedItem in update_agency_logs">
                      <tr
                        v-for="(item, itemIndex) in groupedItem.data"
                        :key="item.id"
                      >
                        <template v-if="itemIndex === 0">
                          <td
                            :rowspan="groupedItem.data.length"
                            class="border dark:border-dark-5 text-center"
                          >
                            {{
                              formartLocalAsUTCAndThenLocal(
                                groupedItem.updateDate
                              )
                            }}
                          </td>
                        </template>
                        <td class="border dark:border-dark-5 text-center">
                          {{ item.modificationDetails }}
                        </td>
                        <td class="border dark:border-dark-5 text-center">
                          <p v-if="isIntegerString(item.originalValue)">
                            {{ formatIntIfString(item.originalValue) }}
                          </p>
                          <p v-else>
                            {{ item.originalValue }}
                          </p>
                        </td>
                        <td class="border dark:border-dark-5 text-center">
                          <p v-if="isIntegerString(item.updatedValue)">
                            {{ formatIntIfString(item.updatedValue) }}
                          </p>
                          <p v-else>
                            {{ item.updatedValue }}
                          </p>
                        </td>
                        <td class="border dark:border-dark-5 text-center">
                          <p v-if="isIntegerString(item.updatedValue)">
                            <span
                              v-if="item.updatedValue - item.originalValue > 0"
                              style="color: red;"
                            >
                              +{{
                                formatIntIfString(
                                  String(item.updatedValue - item.originalValue)
                                )
                              }}
                            </span>
                            <span
                              v-else-if="
                                item.updatedValue - item.originalValue < 0
                              "
                              style="color: lightskyblue;"
                            >
                              -{{
                                formatIntIfString(
                                  String(item.originalValue - item.updatedValue)
                                )
                              }}
                            </span>
                          </p>
                          <p></p>
                        </td>
                        <td class="border dark:border-dark-5 text-center">
                          {{ item.notes }}
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="px-5 pb-8 text-center">
            <el-pagination
              background
              layout="sizes, prev, pager, next, jumper"
              :total="update_agency_page_info.total"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="update_agency_page_info.pageSize"
              :current-page="update_agency_page_info.currentPage"
              @current-change="onUpdateAgencyLogsPageChange"
              @size-change="onUpdateAgencyLogsSizeChange"
            ></el-pagination>
          </div>
          <div class="px-5 pb-8 text-center">
            <button
              type="button"
              class="button w-20 bg-theme-1 text-white dark:border-dark-1 dark:text-white mr-1"
              @click="hideModal"
            >
              닫기
            </button>
          </div>
        </div>
      </div>
      <!-- END: Update History Modal -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Toastify from "toastify-js";
import jQuery from "jquery";
import cash from "cash-dom";

export default {
  data() {
    return {
      categories: [],
      register: {
        id: "",
        name: "",
        hundredAmount: 0,
        fiveHundredAmount: 0,
        bankAmount: 0,
        localAmount: 0,
        notes: "",
      },
      originalRegister: {
        id: "",
        bankAmount: 0,
        localAmount: 0
      },
      formatRegister: {
        tempBankAmount: "",
        tempLocalAmount: ""
      },
      selectedAgency: null,
      update_agency_logs: [],
      update_agency_page_info: {
        total: 0,
        pageSize: 10,
        currentPage: 1
      },
      update_agency_pages_days: ["", ""],
      LogStartDay: "",
      LogEndDay: "",
      isModalOpen: false,
      isSubmitting: false
    };
  },
  async mounted() {
    await this.tokenLogin();
    this.getAgencies();
  },
  async created() {
    window.addEventListener("keyup", this.functionEnter);
  },
  methods: {
    async tokenLogin() {
      let data = {
        token: window.localStorage.getItem("exchange_token")
      };
      let resultData = {};
      await axios.post(this.$api().tokenLogin, data).then(res => {
        resultData = res.data;
      });
      if (this.$h.isEmpty(resultData)) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else if (resultData.error) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else {
        this.$store.commit("auth/SET_USER", resultData.userData);
        this.$store.commit("auth/SET_ISLOGINED", true);
        window.localStorage.setItem(
          "exchange_token",
          resultData.userData.token
        );
      }
    },
    async functionEnter(ev) {
      if (ev.key == "Escape") {
        cash("#edit-modal-preview").modal("hide");
        cash("#delete-confirmation-modal").modal("hide");
        cash("#format-confirmation-modal").modal("hide");
        cash("#header-footer-modal-preview").modal("hide");
        cash("#update-confirmation-modal").modal("hide");
        cash("#update-history-modal").modal("hide");
        this.formatRegister.tempBankAmount = "￦ 0";
        this.formatRegister.tempLocalAmount = "￦ 0";
      }
      window.removeEventListener("beforeunload", this.functionEnter);
    },
    async getAgencies() {
      await axios.post(this.$api().getAgencies).then(res => {
        let resultData = this.$h.assign(res.data);
        if (this.$store.state.auth.user?.isAdmin == 1) {
          this.categories = resultData.data;
        } else {
          let tmpCategories = resultData.data;
          this.categories = this.$h.findItemFromArray(
            tmpCategories,
            this.$store.state.auth.user.agencyId
          );
        }
      });
    },
    inputEmailEnter() {
      jQuery("#inputLocalAmount").focus();
    },
    inputLocalAmountEnter() {
      jQuery("#inputBankAmount").focus();
    },
    inputBankAmountEnter() {
      cash("#header-footer-modal-preview").modal("hide");
      this.handleRegister();
    },
    async onChangeAgencyHistoryLogDay() {
      await this.GetUpdateAgencyLogs(this.originalRegister.id);
    },
    clickAddBtn() {
      this.register.id = "";
      this.register.name = "";
      this.register.hundredAmount = 0;
      this.register.fiveHundredAmount = 0;
      this.register.bankAmount = 0;
      this.register.localAmount = 0;
      // console.log("agency add btn clicked");
      cash("#header-footer-modal-preview").modal("toggle");
    },
    clickEditBtn(agency) {
      // console.log(agency);
      this.originalRegister.id = agency.id;
      this.originalRegister.bankAmount = parseInt(String(agency.bankAmount));
      this.originalRegister.localAmount = parseInt(String(agency.localAmount));
      if (isNaN(this.originalRegister.localAmount)) {
        this.originalRegister.localAmount = 0;
      }
      if (isNaN(this.originalRegister.bankAmount)) {
        this.originalRegister.bankAmount = 0;
      }
      this.register.id = agency.id;
      this.register.name = agency.name;
      this.register.hundredAmount = agency.hundredAmount;
      this.register.fiveHundredAmount = agency.fiveHundredAmount;
      this.register.bankAmount = parseInt(String(agency.bankAmount));
      this.register.localAmount = parseInt(String(agency.localAmount));
      if (agency.localAmount == 0 || isNaN(this.register.localAmount)) {
        this.formatRegister.tempLocalAmount = "￦ 0";
        this.register.localAmount = 0;
      } else {
        this.formatRegister.tempLocalAmount =
          "￦ " + this.register.localAmount.toLocaleString();
      }
      if (agency.bankAmount == 0 || isNaN(this.register.bankAmount)) {
        this.formatRegister.tempBankAmount = "￦ 0";
        this.register.bankAmount = 0;
      } else {
        this.formatRegister.tempBankAmount =
          "￦ " + this.register.bankAmount.toLocaleString();
      }

      this.register.notes = "";
      // console.log("fomartRegister : ", this.formatRegister);
      cash("#edit-modal-preview").modal("toggle");
    },
    async clickHistoryBtn(agency) {
      // console.log(agency);
      this.originalRegister.id = agency.id;
      this.originalRegister.bankAmount = agency.bankAmount;
      this.originalRegister.localAmount = agency.localAmount;
      await this.GetUpdateAgencyLogs(agency.id);
      cash("#update-history-modal").modal("toggle");
    },
    clickDeleteBtn(agency) {
      if (cash("#delete-confirmation-modal").hasClass("show")) {
        this.handleDelete();
      }
      this.selectedAgency = agency;
      cash("#delete-confirmation-modal").modal("toggle");
    },
    hideModal() {
      cash("#update-history-modal").modal("hide");
    },
    formartLocalAsUTCAndThenLocal(localTimeString) {
      //// console.log("localTimeString : ", localTimeString);
      // 1. 로컬 시간을 밀리초로 변환
      const localTimeMilliseconds = new Date(localTimeString).getTime();

      // 2. 현재 시스템의 시간대 오프셋 (분 단위)
      const timezoneOffsetMinutes = new Date().getTimezoneOffset();

      // 3. 시간대 오프셋을 밀리초로 변환
      const timezoneOffsetMilliseconds = timezoneOffsetMinutes * 60 * 1000;

      // 4. 로컬 시간 밀리초에서 오프셋을 빼서 UTC 밀리초를 얻음
      const utcTimeMilliseconds =
        localTimeMilliseconds + timezoneOffsetMilliseconds;

      // 5. UTC 밀리초를 Date 객체로 생성
      const utcDate = new Date(utcTimeMilliseconds);

      // 6. UTC Date 객체를 현지 시간 형식으로 포맷팅
      const year = utcDate.getFullYear();
      const month = String(utcDate.getMonth() + 1).padStart(2, "0");
      const day = String(utcDate.getDate()).padStart(2, "0");
      const hour = String(utcDate.getHours()).padStart(2, "0");
      const minute = String(utcDate.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day} ${hour}:${minute}`;
    },
    async GetUpdateAgencyLogs(agencyId) {
      // console.log("getUpdateAgencyLogs agencyId : ", agencyId);
      this.LogStartDay = "";
      this.LogEndDay = "";
      if (
        this.update_agency_pages_days[0] == null ||
        this.update_agency_pages_days[0] == ""
      ) {
        this.LogStartDay = "";
      } else {
        this.LogStartDay = this.update_agency_pages_days[0];
      }
      if (
        this.update_agency_pages_days[1] == null ||
        this.update_agency_pages_days[1] == ""
      ) {
        this.LogEndDay = "";
      } else {
        this.LogEndDay = this.update_agency_pages_days[1];
      }
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token),
        agencyId: agencyId,
        pageSize: this.update_agency_page_info.pageSize,
        currentPage: this.update_agency_page_info.currentPage,
        totalSize: this.update_agency_page_info.total,
        startDay: this.LogStartDay,
        endDay: this.LogEndDay
      };
      //// console.log("data : ", data);
      await axios.post(this.$api().getUpdateAgencyLogs, data).then(res => {
        this.update_agency_logs = res.data.data;
        this.update_agency_page_info.total = res.data.total;
        this.update_agency_logs.sort((a, b) => {
          const dateA = new Date(a.updateDate);
          const dateB = new Date(b.updateDate);
          return dateB.getTime() - dateA.getTime(); // 내림차순 (미래 -> 과거)
        });
        //// console.log("type of result data", typeof res.data.data);
        //// console.log("getUpdateTransLogs : ", this.update_agency_logs);
      });
    },
    async handleRegister() {
      let data = {
        name: this.register.name,
        hundredAmount: this.register.hundredAmount,
        fiveHundredAmount: this.register.fiveHundredAmount,
        bankAmount: this.$h.convertCommaStrToInt(this.register.bankAmount),
        localAmount: this.$h.convertCommaStrToInt(this.register.localAmount),
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().addAgency, data).then(res => {
        if (res.status == 201) {
          Toastify({
            text: res.data.error,
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: "bottom",
            position: "left",
            backgroundColor: "#e53231",
            stopOnFocus: true
          }).showToast();
        } else if (res.status == 200) {
          this.getAgencies();
        }
      });
    },
    async handleDelete() {
      if (this.selectedAgency.id == this.$store.state.auth.user.agencyId) {
        Toastify({
          text: "사용중인 지점이므로 삭제하실수 없습니다.",
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "bottom",
          position: "left",
          backgroundColor: "#e53231",
          stopOnFocus: true
        }).showToast();
        return;
      }
      let data = {
        id: this.selectedAgency.id,
        agencyId: this.selectedAgency.id,
        token: this.$h.assign(this.$store.state.auth.user.token)
      };

      await axios.post(this.$api().formatAgency, data);

      await axios.post(this.$api().deleteAgency, data).then(res => {
        if (res.status == 200) {
          this.getAgencies();
        }
      });
    },
    onClickFormat() {
      cash("#format-confirmation-modal").modal("toggle");
    },
    onClickUpdate(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (this.isModalOpen || this.isSubmitting) return;

      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }

      this.isModalOpen = true; 
      const modal = cash("#update-confirmation-modal");
      if (!modal.hasClass("show")) { // 이미 떠있지 않을 때만 show
        modal.modal("show");
      }

      window.removeEventListener("keydown", this.handleUpdateKeyPress);
      window.addEventListener("keydown", this.handleUpdateKeyPress);
    },
    handleUpdateKeyPress(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (!this.isModalOpen || this.isSubmitting) {
          return;
        }

        window.removeEventListener("keydown", this.handleUpdateKeyPress);
        this.handleConfirmUpdate();
      }
    },
    isIntegerString(value) {
      return typeof value === "string" && /^-?\d+$/.test(value);
    },
    formatIntIfString(value) {
      if (this.isIntegerString(value)) {
        const num = parseInt(value, 10);
        return num.toLocaleString();
      }
      return 0;
    },
    async onUpdateAgencyLogsPageChange(newPage) {
      this.update_agency_page_info.currentPage = newPage;
      await this.GetUpdateAgencyLogs(this.originalRegister.id);
    },
    async onUpdateAgencyLogsSizeChange(newSize) {
      this.update_agency_page_info.currentPage = 1;
      this.update_agency_page_info.pageSize = newSize;
      // console.log("agencyId : ", this.originalRegister.id);
      await this.GetUpdateAgencyLogs(this.originalRegister.id);
    },
    async handleFormat() {
      cash("#edit-modal-preview").modal("hide");
      this.formatRegister.tempBankAmount = "";
      this.formatRegister.tempLocalAmount = "";
      let data = {
        agencyId: this.register.id,
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().formatAgency, data).then(res => {
        if (res.status == 201) {
          Toastify({
            text: res.data.error,
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: "bottom",
            position: "left",
            backgroundColor: "#e53231",
            stopOnFocus: true
          }).showToast();
        } else if (res.status == 200) {
          this.getAgencies();
        }
      });
    },
    async handleUpdateAgencyLog() {
      let differences = [];
      let updateDate = new Date();
      // 비고(note)를 로그에 포함 (수정 사유가 있을 때만 혹은 모든 필드 공통 적용)
      const currentNote = this.register.notes || "";

      for (let key in this.originalRegister) {
        if (String(this.register[key]) !== String(this.originalRegister[key])) {
          let fieldName = "";
          switch (String(key)) {
            case "localAmount":
              fieldName = "원화";
              break;
            case "bankAmount":
              fieldName = "통장잔고";
              break;
            default:
              break;
          }
          if (fieldName == "") {
            continue;
          }
          differences.push({
            agencyId: this.register.id,
            modificationDetails: fieldName,
            updatedValue: String(this.register[key]),
            originalValue: String(this.originalRegister[key]),
            updateDate: updateDate,
            notes: currentNote
          });
        }
      }
      //// console.log(differences);
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token),
        logs: differences
      };
      await axios.post(this.$api().addUpdateAgencysLog, data);
    },
    async handleConfirmUpdate() {      
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      // [수정] 강제 종료 로직 추가
      this.isModalOpen = false;
      window.removeEventListener("keydown", this.handleUpdateKeyPress);

      cash("#update-confirmation-modal").modal("hide");
      cash("#edit-modal-preview").modal("hide");

      setTimeout(() => {
        if (cash("#update-confirmation-modal").hasClass("show")) {
          cash("#update-confirmation-modal").modal("hide");
          cash(".modal-backdrop").remove(); // 배경이 남는 경우 강제 제거
        }
      }, 450);

      try {
        await this.handleUpdateAgencyLog();
        await this.handleUpdate();

        // 모든 API 처리가 끝난 후 안전하게 초기화
        this.formatRegister.tempBankAmount = "";
        this.formatRegister.tempLocalAmount = "";

      } catch (error) {
        console.error("수정 중 오류 발생:", error);
      } finally {
        setTimeout(() => {
          this.isSubmitting = false;
        }, 2000);
      }
    },
    handleFormatAmount(event, type) {
      // let str =
      //   type === 1
      //     ? this.formatRegister.tempLocalAmount
      //     : this.formatRegister.tempBankAmount;
      //let hasMinus = str.startsWith("-");
      let newValue = event.target.value;
      let newStrWithoutFormat = newValue.replace(/[^0-9-]/g, ""); // 숫자와 '-'만 허용

      if (
        newStrWithoutFormat.startsWith("-") &&
        newStrWithoutFormat.length > 1
      ) {
        newStrWithoutFormat =
          "-" + newStrWithoutFormat.substring(1).replace(/-/g, ""); // 첫 글자 '-' 외의 '-' 제거
      } else {
        newStrWithoutFormat = newStrWithoutFormat.replace(/-/g, ""); // '-' 모두 제거
      }

      let numericValue = parseInt(newStrWithoutFormat);

      if (type === 1) {
        if (!isNaN(numericValue)) {
          this.register.localAmount = numericValue;
          this.formatRegister.tempLocalAmount =
            (numericValue < 0 ? "₩ -" : "₩ ") +
            Math.abs(numericValue).toLocaleString();
        } else if (newValue === "-") {
          this.formatRegister.tempLocalAmount = "₩ -";
          this.register.localAmount = 0; // 또는 null 등 초기값 설정
        } else {
          this.register.localAmount = 0;
          this.formatRegister.tempLocalAmount = "";
        }
      } else if (type === 2) {
        if (!isNaN(numericValue)) {
          this.register.bankAmount = numericValue;
          this.formatRegister.tempBankAmount =
            (numericValue < 0 ? "₩ -" : "₩ ") +
            Math.abs(numericValue).toLocaleString();
        } else if (newValue === "-") {
          this.formatRegister.tempBankAmount = "₩ -";
          this.register.bankAmount = 0; // 또는 null 등 초기값 설정
        } else {
          this.register.bankAmount = 0;
          this.formatRegister.tempBankAmount = "";
        }
      }
    },
    async handleUpdate() {
      let data = {
        id: this.register.id,
        name: this.register.name,
        hundredAmount: this.register.hundredAmount,
        fiveHundredAmount: this.register.fiveHundredAmount,
        bankAmount: this.$h.convertCommaStrToInt(this.register.bankAmount),
        localAmount: this.$h.convertCommaStrToInt(this.register.localAmount),
        token: this.$h.assign(this.$store.state.auth.user.token),
      };
      await axios.post(this.$api().editAgency, data).then(res => {
        if (res.status == 201) {
          Toastify({
            text: res.data.error,
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: "bottom",
            position: "left",
            backgroundColor: "#e53231",
            stopOnFocus: true
          }).showToast();
        } else if (res.status == 200) {
          this.getAgencies();
        }
      });
    },
    onChangeInputBankAmount() {
      this.register.bankAmount = this.$h.filterCurrency(
        this.$h.convertCommaStrToInt(this.register.bankAmount)
      );
    },
    onChangeInputLocalAmount() {
      this.register.localAmount = this.$h.filterCurrency(
        this.$h.convertCommaStrToInt(this.register.localAmount)
      );
    }
  }
};
</script>
